/**
 * Wheel Spin Utility
 * Provides the window.spin function for rotating the wheel
 * Based on jQuery rotate plugin - adapted for React
 */

if (typeof window !== 'undefined') {
  // Initialize window.spin function
  window.spin = (spinAngle) => {
    // Try to find the wheel element with retry mechanism
    const findWheelElement = (retries = 5, delay = 100) => {
      const wheelElement = document.querySelector('.wheel');
      
      if (wheelElement) {
        performSpin(wheelElement, spinAngle);
        return;
      }
      
      if (retries > 0) {
        setTimeout(() => findWheelElement(retries - 1, delay), delay);
      }
    };
    
    findWheelElement();
  };
  
  const performSpin = (wheelElement, spinAngle) => {
    // Normalize spinAngle to be between 0 and 360
    const normalizedAngle = ((spinAngle % 360) + 360) % 360;
    
    // Reset rotation to 0 first
    wheelElement.style.transform = 'rotate(0deg)';
    wheelElement.style.transition = 'none';
    wheelElement.style.transformOrigin = 'center center';
    
    // Force reflow to ensure reset is applied
    void wheelElement.offsetHeight;
    
    // Calculate target angle: multiple full rotations (2160 = 6 full rotations) + the target angle
    // The spinAngle represents the position on the wheel where the winning segment is located
    // To position this segment at the pointer (top = 0°), we need to rotate the wheel
    // by (360 - normalizedAngle) degrees clockwise
    const targetFinalAngle = 360 - normalizedAngle;
    const fullRotations = 2160; // 6 full rotations for visual effect
    const targetAngle = fullRotations + targetFinalAngle;
    const duration = 6000; // 6 seconds
    
    // Apply smooth rotation animation with easing
    wheelElement.style.transition = `transform ${duration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
    wheelElement.style.transform = `rotate(${targetAngle}deg)`;
    
    // Stop animation after duration and set final position precisely
    setTimeout(() => {
      // Remove transition to prevent any further animation
      wheelElement.style.transition = 'none';
      
      // Always use the calculated targetFinalAngle to ensure precision
      // This is the exact angle we want the wheel to stop at
      wheelElement.style.transform = `rotate(${targetFinalAngle}deg)`;
    }, duration);
  };
}

export default window.spin;
